import 'jquery-simplecolorpicker'
import 'jquery-simplecolorpicker.css'
import $ from 'jquery'

export default function colorpicker(element) {
  var elem = $(element)
  var cols = elem.data('colors').split(/,/).map((n) => '#' + n)
  var sel = cols[parseInt(elem.val().replace(/[A-z]*/, '')) - 1]
  elem.hide()
  var b = _(cols).map(
    (c) => '<option value="' + c + '" ' + (c == sel ? 'selected' : '') + '>' + c + '</option>'
  )
  var a = $('<select>' + b.join('') + '</select>')
  $(elem).after(a)
  a.simplecolorpicker({ picker: true }).on('change', function () {
    var pos = _(cols).indexOf($(elem).val())
    $(elem).val('Color' + (pos + 1))
  })
}
